import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { Email } from "@mui/icons-material";

/**
 * Email SMTP Node — Enviar email via SMTP.
 *
 * data.smtpHost: string — servidor SMTP
 * data.smtpPort: number — porta (465, 587, 25)
 * data.smtpUser: string — usuario
 * data.smtpPass: string — senha (encriptada)
 * data.smtpSecure: boolean — usar SSL/TLS
 * data.from: string — email remetente
 * data.to: string — destinatario(s) separados por virgula
 * data.subject: string — assunto
 * data.body: string — corpo do email (HTML ou texto)
 * data.attachments: array — anexos
 *
 * Saidas: handle "sent" (enviado), handle "error" (falhou)
 */
const EmailSmtpNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const to = data?.to || "";
  const subject = data?.subject || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Email />}
      title="Email SMTP"
      color="#1565C0"
      bgColor="#E3F2FD"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 11,
      }}>
        {to && (
          <div style={{ color: "#666", fontSize: 10 }}>
            <span style={{ color: "#999" }}>Para: </span>
            <span style={{ fontWeight: 600 }}>
              {to.substring(0, 35)}{to.length > 35 ? "..." : ""}
            </span>
          </div>
        )}
        {subject && (
          <div style={{ color: "#666", fontSize: 10, marginTop: 2 }}>
            <span style={{ color: "#999" }}>Assunto: </span>
            {subject.substring(0, 40)}{subject.length > 40 ? "..." : ""}
          </div>
        )}
        {!to && !subject && (
          <div style={{ color: "#999", fontSize: 10, fontStyle: "italic" }}>
            Configurar email SMTP
          </div>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4, padding: "2px 10px",
          }}>ENVIADO</span>
          <Handle type="source" position={Position.Right} id="sent"
            className={getHandleClass("source", "sent")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#f44336", borderRadius: 4, padding: "2px 10px",
          }}>ERRO</span>
          <Handle type="source" position={Position.Right} id="error"
            className={getHandleClass("source", "error")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
      </div>
    </NodeWrapper>
  );
});

EmailSmtpNode.displayName = "EmailSmtpNode";
export default EmailSmtpNode;
